import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VuePageTransition from 'vue-page-transition';
import VueI18n from 'vue-i18n';
import messages from './messages';

Vue.config.productionTip = false;

Vue.use(VuePageTransition);
Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

new Vue({
  data: function() {
    return {
      showNav: true,
      headline: 'OMNIplus ON Monitor',
      subheadline: 'For efficient fleet management.',
    }
  },
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");
